import { reactive } from 'vue';

export interface ConfirmOptions {
  title: string;
  body: string;
  /** The button names the action: "Ekipten çıkar", not "Tamam". */
  confirmLabel: string;
  danger?: boolean;
  /** Asks for a written reason too (voiding a payment); the label of that field. */
  reasonLabel?: string;
}

interface ConfirmState extends ConfirmOptions {
  reason: string;
  open: boolean;
  resolve: ((ok: boolean) => void) | null;
}

export const confirmState = reactive<ConfirmState>({
  open: false,
  title: '',
  body: '',
  confirmLabel: '',
  danger: false,
  reasonLabel: undefined,
  reason: '',
  resolve: null,
});

/** Asks in the app's own dialog, never the browser's. Resolves true when confirmed. */
export function confirm(options: ConfirmOptions): Promise<boolean> {
  confirmState.resolve?.(false);
  Object.assign(confirmState, {
    danger: false,
    reasonLabel: undefined,
    ...options,
    reason: '',
    open: true,
  });
  return new Promise((resolve) => {
    confirmState.resolve = resolve;
  });
}

export function settleConfirm(ok: boolean): void {
  confirmState.resolve?.(ok);
  confirmState.resolve = null;
  confirmState.open = false;
}

/** Like confirm, with a required reason; resolves the reason, or null when cancelled. */
export async function confirmWithReason(
  options: ConfirmOptions & { reasonLabel: string },
): Promise<string | null> {
  const ok = await confirm(options);
  return ok ? confirmState.reason.trim() : null;
}
